<template>
  <div class="cashcreation">
    <div class="header-text"
         :style="{ width: ElementHeight }">
      <h1 class="header-title">积分商城商品管理—创建（礼品）</h1>
      <div class="buttom-div">
        <el-button class="push-button"
                   @click="Createasave">保存</el-button>
        <el-button class="push-button"
                   icon="iconfont icon-fanhui"
                   @click="clearbtn">返回</el-button>
      </div>
    </div>
    <div class="header-text1"></div>
    <div>
      <el-card shadow="never"
               class="card-center"
               style="margin-top: 10px">
        <!-- 选择礼品弹窗 -->
        <div class="choice">
          <el-dialog width="45%"
                     title="选择礼品"
                     :visible.sync="innerVisible"
                     :close-on-click-modal="false">
            <el-button icon="el-icon-search"
                       @click="Seacharbtn"
                       style="margin-left: 88%; margin-bottom: 10px; margin-top: -20px">查询</el-button>
            <el-form size="mini"
                     :label-position="labelPosition"
                     label-width="80px">
              <el-row>
                <el-col>
                  <el-form-item label="礼品编号">
                    <el-input v-model="Position.giftNo"
                              style="width: 75%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="礼品名称">
                    <el-input v-model="Position.giftName"
                              style="width: 75%">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="width: 100%; margin-top: 10px">
              <el-table size="mini"
                        class="table-style"
                        border
                        :row-class-name="tableRowClassName"
                        :header-cell-style="{
                  background: '#FCFBF2',
                  color: '#6C6839',
                  'text-align': 'center',
                }"
                        :cell-style="{ 'text-align': 'center' }"
                        ref="multipleTable"
                        :data="SkuList"
                        tooltip-effect="dark"
                        v-el-table-infinite-scroll="true"
                        infinite-scroll-disabled="true">
                <el-table-column width="40">
                  <template slot-scope="scope">
                    <el-radio v-model="radioId"
                              :label="scope.$index"
                              @change.native="handleRadioChange(scope.row)">&nbsp;
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="giftNo"
                                 label="礼品编码">
                </el-table-column>
                <el-table-column prop="giftName"
                                 label="礼品名称">
                </el-table-column>
                <el-table-column prop="giftKind"
                                 label="礼品类型">
                  <template scope="scope">
                    {{
                      scope.row.giftKind === 0
                        ? "成衣"
                        : "" || scope.row.giftKind === 1
                        ? "革履"
                        : "" || scope.row.giftKind === 2
                        ? "配饰"
                        : "" || scope.row.giftKind === 3
                        ? "非公司商品"
                        : ""
                    }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div slot="footer"
                 class="dialog-footer">
              <el-button @click="Eacmentbtn">确 定</el-button>
              <el-button @click="innerVisible = false">取 消</el-button>
            </div>
          </el-dialog>
        </div>
        <!-- 礼品券库弹窗 -->
        <div class="present">
          <el-dialog width="40%"
                     title="选择券库"
                     :visible.sync="innerVisibleLier"
                     :close-on-click-modal="false">
            <el-form size="mini"
                     :label-position="labelPosition"
                     label-width="120px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="券名称">
                    <el-input v-model="queryArr.couponsName"> </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="券类型">
                    <div>
                      <el-select style="width: 55%"
                                 v-model="queryArr.couponsKind">
                        <el-option label="现金券"
                                   value="0"> </el-option>
                        <el-option label="折扣券"
                                   value="1"> </el-option>
                        <el-option label="礼品券"
                                   value="2"> </el-option>
                        <el-option label="异业券"
                                   value="3"> </el-option>
                      </el-select>
                      <el-button icon="el-icon-search"
                                 @click="Seachbtn">查询</el-button>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="创建时间">
                    <el-date-picker v-model="queryArr.createTime"
                                    type="date"
                                    placeholder="选择时间"
                                    value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="至">
                    <el-date-picker v-model="queryArr.updateTime"
                                    type="date"
                                    placeholder="选择时间"
                                    value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="width: 100%; margin-top: 10px">
              <el-table height="300"
                        class="table-style"
                        border
                        :row-class-name="tableRowClassName"
                        :header-cell-style="{
                  background: '#FCFBF2',
                  color: '#6C6839',
                  'text-align': 'center',
                }"
                        :cell-style="{ 'text-align': 'center' }"
                        ref="multipleTable"
                        :data="queryList"
                        tooltip-effect="dark">
                <el-table-column width="40">
                  <template slot-scope="scope">
                    <el-radio v-model="radioes"
                              :label="scope.$index"
                              @change.native="handleRadioChangeV(scope.row)">&nbsp;
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="couponsName"
                                 label="券名称">
                </el-table-column>
                <el-table-column prop="innerCoupName"
                                 label="券后台名称">
                </el-table-column>
                <el-table-column prop="couponsKind"
                                 label="券类型">
                  <template scope="scope">
                    {{
                      scope.row.couponsKind === 0
                        ? " 现金券"
                        : "" || scope.row.couponsKind === 1
                        ? "折扣券"
                        : "" || scope.row.couponsKind === 2
                        ? "礼品券"
                        : "" || scope.row.couponsKind === 3
                        ? "异业券"
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="createUserName"
                                 label="创建人">
                </el-table-column>
                <el-table-column prop="createTime"
                                 label="创建时间">
                  <template scope="scope">
                    {{ scope.row.createTime | dateFormats }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div slot="footer"
                 class="dialog-footer">
              <el-button @click="determine">确 定</el-button>
              <el-button @click="innerVisibleLier = false">取 消</el-button>
            </div>
          </el-dialog>
        </div>
        <!-- 表单 -->
        <div>
          <el-form size="small"
                   :label-position="labelPosition"
                   label-width="100px"
                   :model="ruleForm"
                   :rules="rules"
                   ref="ruleForms">
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品"
                              prop="giftName">
                  <div style="display: flex">
                    <el-input v-model="ruleForm.giftName"
                              readonly
                              style="width:80%;"></el-input>
                    <el-button style="margin-left: 10px"
                               @click="Earchbtn">选择礼品</el-button>
                    <span style="color:blue;line-height: 16px;margin-left:12px">说明：选择礼品主数据</span>
                  </div>

                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="商品名称"
                              prop="commodityName">
                  <el-input v-model="ruleForm.commodityName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品券库"
                              prop="couponsName">
                  <div class="flex-between">
                    <el-input v-model="ruleForm.couponsName"
                              readonly
                              @click.native="giftDaTeurl"
                              style="width:80%"></el-input>
                    <el-button style="margin-left: 10px"
                               @click="SearchJuan">选择券库</el-button>
                    <span style="color:blue;line-height: 18px;margin-left:12px">说明：选择礼品库，显示礼品库名称，点击跳转到券库详情</span>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9"
                      style="margin-top: 50px; margin-left: -38%">
                <el-form-item label="商品详情">
                  <editor v-model="ruleForm.commDetail"
                          :min-height="192"
                          :disabled="ruleForm.state != 1" />
                  <span style="color:blue">说明：商品详情可以输入文字、图片等内容</span>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="封面图">
                  <div style="width: 100%">
                    <span style="color: #c9b916">说明：最多3张图片，规格：长*宽；格式：JPG，PNG；大小：xxMB</span>
                  </div>
                  <el-upload :http-request="handleImports"
                             :limit="3"
                             action="#"
                             list-type="picture-card">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog>
                    <img width="100%"
                         alt="" />
                  </el-dialog>
                </el-form-item>
              </el-col>
              <el-col :span="9"> </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="颜色">
                  <div class="checkbox">
                    <el-checkbox-group v-model="colorcheckList">
                      <el-checkbox name="type"
                                   v-for="item in colorList"
                                   :key="item.colorAttrID"
                                   :label="item.colorAttrID">{{ item.colorName }}

                        <div style="width: 100%">
                          <span style="color: #c9b916">说明：最多3张图片，规格：长*宽；格式：JPG，PNG；大小：xxMB</span>
                        </div>
                        <el-upload :data="{ id: item.colorAttrID }"
                                   :http-request="handleImport"
                                   :limit="3"
                                   action="#"
                                   list-type="picture-card">
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </el-checkbox>
                    </el-checkbox-group>
                    <el-dialog>
                      <img width="100%"
                           alt="" />
                    </el-dialog>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="SKU">
                  <el-table @selection-change="handleSelectionChange"
                            size="mini"
                            class="table-style"
                            border
                            :row-class-name="tableRowClassName"
                            :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                            :cell-style="{ 'text-align': 'center' }"
                            ref="multipleTable"
                            :data="tCommskustockList"
                            tooltip-effect="dark">
                    <el-table-column label
                                     width="35"
                                     type="index">
                    </el-table-column>
                    <el-table-column prop="productSKU"
                                     label="礼品SKU">
                    </el-table-column>
                    <el-table-column prop="colorName"
                                     label="颜色">
                    </el-table-column>
                    <el-table-column prop="sizeName"
                                     label="尺码">
                    </el-table-column>
                    <el-table-column prop="stockQty"
                                     label="库存数量">
                      <template scope="scope">
                        <el-input v-model="scope.row.stockQty"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="selectOption"
                                     label="是否上架">
                      <template scope="scope">
                        <el-checkbox :checked="scope.row.selectOption === 1 ? true : false"
                                     @change="
                            checkboxCliock(
                              scope.row.giftSKUID,
                              scope.row.selectOption
                            )
                          "></el-checkbox>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column type="selection"
                                     width="55"
                                     label="是否上架">
                    </el-table-column> -->
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="吊牌价">
                  <el-input v-model="ruleForm.lblPrice"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="领取方式"
                              prop="collectMethod">
                  <!-- <el-select style="width: 100%"
                             v-model="ruleForm.collectMethod"> -->
                  <!-- <el-option label="到店自取"
                               value="1"> </el-option>
                    <el-option label="快递邮寄"
                               value="2"> </el-option> -->
                  <el-checkbox-group v-model="ruleForm.collectMethod"
                                     @change="selectValue">
                    <el-checkbox label="1">到店自取</el-checkbox>
                    <el-checkbox label="2">快递邮寄</el-checkbox>
                  </el-checkbox-group>
                  <!-- </el-select> -->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="领取期限">
                  <el-input v-model="ruleForm.deadLine"
                            style="width: 180px"></el-input>
                  &nbsp;&nbsp;天
                  <span style="margin-left: 30px; color: blue">说明：仅限大于1的数字</span>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最大兑换数量">
                  <el-input v-model="ruleForm.maxNum"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="兑换日期"
                              required="">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item prop="startDate">
                        <el-date-picker type="date"
                                        placeholder="开始日期"
                                        v-model="ruleForm.startDate"
                                        style="width: 100%"></el-date-picker>

                      </el-form-item>
                    </el-col>
                    <el-col class="line"
                            style="text-align: center"
                            :span="2">至</el-col>
                    <el-col :span="11">
                      <el-date-picker type="date"
                                      placeholder="结束日期"
                                      v-model="ruleForm.endDate"
                                      style="width: 100%"></el-date-picker>
                      <span style="color:blue">说明：结束日期为空表示长期</span>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="兑换积分"
                              prop="creditPoint">
                  <el-input v-model="ruleForm.creditPoint"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="限制销售等级">
                  <el-checkbox label="限制"
                               name="type"
                               v-model="myisShow"
                               :indeterminate="isIndeterminate"
                               @change="handleCheckAlllevel">
                  </el-checkbox>
                  <el-checkbox-group v-model="checkedCities"
                                     @change="handValuet">
                    <div style="width: 200px; border: 1px solid #ccc">
                      <div style="margin-left: 20px">
                        <div>
                          <el-checkbox v-for="item in checkList"
                                       :key="item.levelID"
                                       :label="item.levelID">
                            {{ item.levelName_cn }}
                          </el-checkbox>
                        </div>
                      </div>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="置顶排序">
                  <el-checkbox-group v-model="ruleForm.top">
                    <div style="display: flex">
                      <el-checkbox label="置顶"
                                   name="type"></el-checkbox>
                      <el-input style="margin-left: 10px;"
                                v-model="ruleForm.topSortIndex"></el-input>

                    </div>

                  </el-checkbox-group>
                  <span style="color:blue;margin-left:17%">说明：只允许填写数字</span>
                </el-form-item>
                <el-form-item label="允许兑换维护店" label-width="120px">
                  <el-radio-group v-model="ruleForm.allServShop">
                    <div style="display: flex;align-items: center;">
                      <el-radio :label="true">全部门店</el-radio>
                      <el-radio :label="false">部分门店</el-radio>
                      <el-button
                        @click="outletVisible = true"
                        style="height: 35px; line-height: 10px;margin-left: 15px;"
                        :disabled="ruleForm.allServShop"
                        >选择门店</el-button
                      >
                    </div>
                  </el-radio-group>
                  <div style="padding-top: 20px;" v-if="!ruleForm.allServShop">
                    <textarea
                    style="width: 100%; margin: 0px; padding: 0px"
                    rows="4"
                    readonly
                    v-model="ruleForm.servOrgListStr"
                  ></textarea>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="核销提醒方式">
                  <el-radio-group v-model="ruleForm.pubVeriCoupMode">
                    <el-radio label="0">不提醒</el-radio>
                    <el-radio label="1">公众号模板消息</el-radio>
                    <el-radio label="2">短信消息</el-radio>
                    <el-radio label="3">公众号模板消息和短信消息 </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="券到期提醒方式">
                  <el-radio-group v-model="ruleForm.expirationMode">
                    <el-radio label="0">不提醒</el-radio>
                    <el-radio label="1">公众号模板消息</el-radio>
                    <el-radio label="2">短信消息</el-radio>
                    <el-radio label="3">公众号模板消息和短信消息 </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="提前提醒">
                  <el-input style="width: 130px"
                            v-model="ruleForm.expirationTime"></el-input>
                  &nbsp; &nbsp;天
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="18">
                <el-form-item label="领取场所限制">
                  <el-radio-group v-model="ruleForm.siteLimitFlag">
                    <el-radio label="0">无限制</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="">
                  <el-radio-group v-model="ruleForm.siteLimitFlag">
                    <el-radio label="2">城市</el-radio>
                    <el-button @click="citybtn">增加</el-button>
                  </el-radio-group>
                  <el-table size="mini"
                            class="table-style"
                            border
                            :row-class-name="tableRowClassName"
                            :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                            :cell-style="{ 'text-align': 'center' }"
                            ref="multipleTable"
                            :data="city"
                            tooltip-effect="dark">
                    <el-table-column label
                                     width="35"
                                     type="index">
                    </el-table-column>
                    <el-table-column prop="siteName"
                                     label="城市">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.siteName"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="hasStock"
                                     label="是否有库存">
                      <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.hasStock"></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="state"
                                     label="状态">
                      <template slot-scope="scope">
                        <!-- <el-input v-model="scope.row.state"></el-input> -->
                        <el-checkbox v-model="scope.row.state"
                                     true-label="0"
                                     false-label="1"></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                     label="操作">
                      <template slot-scope="scope">
                        <el-button type="text"
                                   @click.native.prevent="
                            deletesizeoes(scope.$index, city)
                          ">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="">
                  <el-radio-group v-model="ruleForm.siteLimitFlag">
                    <el-radio label="1">门店</el-radio>
                    <el-button @click="shopbtn">增加</el-button>
                  </el-radio-group>
                  <el-table size="mini"
                            class="table-style"
                            border
                            :row-class-name="tableRowClassName"
                            :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                            :cell-style="{ 'text-align': 'center' }"
                            ref="multipleTable"
                            :data="shop"
                            tooltip-effect="dark">
                    <el-table-column label
                                     width="35"
                                     type="index">
                    </el-table-column>
                    <el-table-column prop="ShopCode"
                                     label="门店">
                      <template slot-scope="scope">
                        <!-- <el-input v-model="scope.row.siteName"></el-input> -->
                        <!-- <el-autocomplete
                              :fetch-suggestions="querySearchAsync"
                              :trigger-on-focus="false"
                              v-model="scope.row.productSKU"
                              @select="handleSelect"
                              style="width: 100%"
                            >
                            </el-autocomplete> -->
                        <el-autocomplete v-model="scope.row.ShopCode"
                                         @select="
                            (item) => {
                              handleSelect(item, scope.row.ShopCode);
                            }
                          "
                                         :fetch-suggestions="querySearch"
                                         placeholder="请输入门店编号">
                        </el-autocomplete>
                      </template>
                    </el-table-column>
                    <el-table-column prop="siteName"
                                     label="门店名称">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.siteName"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column prop="hasStock"
                                     label="是否有库存">
                      <template slot-scope="scope">
                        <!-- <el-input v-model="scope.row.accessoriesSize"></el-input> -->
                        <el-checkbox v-model="scope.row.hasStock"></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="state"
                                     label="状态">
                      <template slot-scope="scope">
                        <!-- <el-input v-model="scope.row.accessoriesSize"></el-input> -->
                        <el-checkbox v-model="scope.row.state"
                                     true-label="0"
                                     false-label="1"></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                     label="操作">
                      <template slot-scope="scope">
                        <el-button type="text"
                                   @click.native.prevent="
                            deletesizebtn(scope.$index, shop)
                          ">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
      <!-- 选择门店弹窗 -->
      <div class="outlet">
        <el-dialog
          :close-on-click-modal="false"
          width="30%"
          :visible.sync="outletVisible"
          title="选择门店"
        >
          <el-form size="mini" label-width="90px">
            <el-row
              :gutter="50"
              v-for="(item, index) in StoreSelectionList"
              :key="index"
            >
              <el-col
                :span="12"
                v-for="(myitem, myindex) in item"
                :key="myindex"
              >
                <el-tree
                  ref="tree"
                  v-if="myitem != undefined"
                  :data="[myitem]"
                  show-checkbox
                  node-key="shopID"
                  highlight-current
                  default-expand-all
                  :default-checked-keys="xuanzhong"
                  :props="defaultProps"
                >
                </el-tree>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="ComButtomStore">确 定</el-button>
            <el-button @click="outletVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reserveGIftSku,
  reserveGIftApi,
  couponsGroupApi,
  upperOrLowerinsert,
  imageupadatApi,
  customerlevelApi,
} from "@/api/Integralquery";
import {
  RegionApi,
} from "@/api/reportForm";
import { shopselectListApi } from "@/api/shop";
import { dateTimes } from '@/utils/auth'
export default {
  name: "centre",
  data () {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      querArrback: {},
      colorcheckList: [], //颜色选中数组
      BoxesList: [], //是否上架选中数组
      innerVisible: false,
      presentVisible: false,
      innerVisibleLier: false,
      labelPosition: "right",
      value1: "",
      checkedCities: [],
      //内置弹窗查询以及数据
      Position: {
        pageSize: "50",
        pageNo: "1",
        giftNo: "", //礼品编码
        giftName: "", //礼品名称
        state: "0",
      },
      ruleForm: {
        allServShop:true,
        commAllowLvlList: [],
        commodityName: "", //商品名称
        commDetail: "", //商品详情
        startDate: "", //开始时期
        endDate: "", //结束日期
        couponsGrpID: "", //券库 ID
        couponsName: "", //券名称
        maxNum: "", //最大兑换数量
        creditPoint: "", //兑换积分
        expirationMode: "0", //到期提醒方式
        pubVeriCoupMode: "0", //核销提醒方式
        allUser: true, //限制销售等级
        top: false, //置顶
        topSortIndex: "", //置顶序列号
        expirationTime: "", //到期提醒天数
        commKind: 1,
        giftID: "", //礼品ID
        lblPrice: "", //吊牌价,
        collectMethod: [],
        deadLine: "", //领取期限
        siteLimitFlag: "0", //领取场限制
        giftName: '' //礼品
      },
       // 选择门店弹窗
       outletVisible: false,
      regionList: [],
      xuanzhong: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      //sku数据存放
      SkuList: [],
      //劵库存放
      queryList: [],
      radioes: "",
      //sku
      tCommskustockList: [],
      //
      //限制
      tCommsitelimitList: [],
      //图片数组
      commColorImgList: [],
      //城市
      city: [],
      //门店
      shop: [],
      //赋值
      handleRadioValue: "",
      radioId: "",
      queryArr: {
        couponsName: "", //卷名称
        couponsKind: '2', //卷类型
        createTime: "",
        updateTime: "",
        state: 0,
        pageSize: "50",
        pageNo: "1",
      },
      JuankuRadios: "",
      checkList: [],
      isIndeterminate: false,
      //门店
      shopList: [],
      //颜色数组
      colorList: [],
      //图片数组
      imageList: [],
      //封面图数据存放
      coverImage: [],
      changItem: "",
      rules: {
        giftName: [
          { required: true, message: "请选择礼品！", trigger: "change" },
        ],
        commodityName: [
          { required: true, message: "商品名称不能为空!", trigger: "change" },
        ],
        couponsName: [
          { required: true, message: "请选择礼品劵库！", trigger: "change" },
        ],
        collectMethod: [
          {
            required: true,
            message: "至少选择一种领取方式！",
            trigger: "change",
          },
        ],
        startDate: [
          { required: true, message: "请输入开始时间", trigger: "change" },
        ],
        creditPoint: [
          { required: true, message: "请输入兑换积分", trigger: "blur" },
        ],
      },
    };
  },
  created () {
    this.customermethods();
  },
  computed: {
    myisShow () {
      return !this.ruleForm.allUser;
    },
  },
  watch: {
    //窗口宽度变化
    screenWidth () {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
  },
  mounted () {
    // 创建弹窗门店模糊搜索
    shopselectListApi().then((res) => {
      if (res.message == "success") {
        res.data.forEach((item) => {
          this.shopList.push({
            // id:item.shopID,
            value: item.ShopCode,
            name: item.ShopName,
            id: item.ShopID,
          });
        });
      }
    });
    this.getELmentHeight()
    this.regionSelectList();
  },
  methods: {
    ComButtomStore() {
      this.ruleForm.servOrgList = [];
      this.ruleForm.servOrgListStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.ruleForm.servOrgList.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.ruleForm.servOrgList.push(...item);
        }
      }
      this.ruleForm.servOrgList.forEach((item) => {
        this.ruleForm.servOrgListStr += `${item.lable}\n`;
      });
      this.xuanzhong = [];
      for (let i = 0; i < this.ruleForm.servOrgList.length; i++) {
        this.xuanzhong.push(this.ruleForm.servOrgList[i].id);
      }
      this.outletVisible = false;
      console.log(this.ruleForm)
    },
    regionSelectList() {
      RegionApi({ regionID: "" }).then((res) => {
        if (res.success) {
          this.regionList.push({
            id: "",
            lable: "全部区域",
          });
          this.regionList.push(...res.data);

          let arr1 = [],
            arr2 = [];
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getELmentHeight () {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //sku数据请求
    async reserveGIft () {
      await reserveGIftApi(this.Position).then((res) => {
        this.SkuList = res.data.list;
      });
    },
    //点击礼品弹层获取数据
    Earchbtn () {
      this.reserveGIft();
      this.innerVisible = true;
    },
    //radio赋值
    handleRadioChange (val) {
      this.handleRadioValue = val;
    },
    //内置弹窗查询
    Seacharbtn () {
      this.reserveGIft();
    },
    //弹窗赋值
    Eacmentbtn () {
      this.ruleForm.commodityName = this.handleRadioValue.giftName;
      this.ruleForm.giftName = this.handleRadioValue.giftName;
      this.ruleForm.giftID = this.handleRadioValue.giftID;
      this.radioId = ''
      this.reserveGIftback();
      this.innerVisible = false;
    },
    handleRadioChangeV (val) {
      this.JuankuRadios = val;
    },
    async Securitieslibrary () {
      let cuarItem = {
        couponsName: this.queryArr.couponsName,
        couponsKind: this.queryArr.couponsKind,
        createTime: this.queryArr.createTime,
        updateTime: this.queryArr.updateTime,
        state: this.queryArr.state,
        pageSize: this.queryArr.pageSize,
        pageNo: this.queryArr.pageNo,
        giftID: this.handleRadioValue.giftID
      }
      await couponsGroupApi(cuarItem).then((res) => {
        this.queryList = res.data.list;
      });
    },
    //劵库查询
    Seachbtn () {
      this.Securitieslibrary();
    },
    //点击劵库获取数据
    SearchJuan () {
      if (this.ruleForm.giftName != '') {
        this.Securitieslibrary();
      }
      this.innerVisibleLier = true;
    },
    determine () {
      this.ruleForm.couponsName = this.JuankuRadios.couponsName;
      this.ruleForm.couponsGrpID = this.JuankuRadios.couponsGrpID;
      this.radioes = ''
      this.innerVisibleLier = false;
    },
    async reserveGIftback () {
      await reserveGIftSku({ giftID: this.ruleForm.giftID }).then((res) => {
        this.tCommskustockList = res.data;
        for (let i = 0; i < this.tCommskustockList.length; i++) {
          const item = this.tCommskustockList[i];
          // this.colorList.push(item)
          item.selectOption = false;
        }
      });

      let colarArray = [];
      this.colorList = [];
      this.tCommskustockList.map((item) => {
        if (colarArray.indexOf(item.colorName) == -1) {
          colarArray.push(item.colorName);
          this.colorList.push(item);
        }
      });
    },
    handleCheckAlllevel (val) {
      let arr = [];
      this.checkedCities = val ? arr : [];

      this.checkList.forEach((item) => {
        arr.push(item.levelID);
      });
      this.isIndeterminate = false;
      this.ruleForm.allUser = !val;
    },
    handValuet (val) {
      let checkedCount = val.length;

      if (val.length !== 0) {
        this.ruleForm.allUser = false;
      } else {
        this.ruleForm.allUser = true;
      }
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.checkList.length;
    },

    handleSelectionChange (val) {
      this.ruleForm.tCommskustockList = val;
      this.ruleForm.tCommskustockList.forEach((item) => {
        item.selectOption = 1;
      });
    },
    //领取方式
    selectValue (val) {
      this.changItem = val.join("");
      if (this.changItem == 12 || this.changItem == 21) {
        this.changItem = "3";
      }
    },
    //礼品创建保存
    Createasave () {
      this.$refs.ruleForms.validate((valid) => {
        if (valid) {
          let arr = [];
          this.checkList.forEach((item) => {
            arr.push(item.levelID);
          });
          this.ruleForm.commAllowLvlList = [];
          for (let i = 0; i < this.checkedCities.length; i++) {
            const item = this.checkedCities[i];
            if (this.ruleForm.allUser != true) {
              this.ruleForm.commAllowLvlList.push({ levelID: item });
            }
          }
          let commColorImgList = [];
          let colorcheckListStr = this.colorcheckList.join(",");
          if (this.imageList.length > 0) {
            this.imageList.map((item) => {
              if (colorcheckListStr.indexOf(item.id) != -1) {
                let x = {};
                x.colorAttrID = item.id;
                if (item.imagesArry.length > 0) {
                  item.imagesArry.map((MyItem, MyIndex) => {
                    let flag = `image${MyIndex + 1}`;
                    x[flag] = MyItem; //映射
                  });
                }
                commColorImgList.push(x);
              }
            });
          }
          this.querArrback = {
            commAllowLvlList: this.ruleForm.commAllowLvlList,
            commodityName: this.ruleForm.commodityName, //商品名称
            commDetail: this.ruleForm.commDetail, //商品详情
            startDate: dateTimes(this.ruleForm.startDate), //开始时期
            endDate: dateTimes(this.ruleForm.endDate), //结束日期
            couponsGrpID: this.ruleForm.couponsGrpID, //券库 ID
            couponsName: this.ruleForm.couponsName, //券名称
            maxNum: this.ruleForm.maxNum, //最大兑换数量
            creditPoint: this.ruleForm.creditPoint, //兑换积分
            expirationMode: this.ruleForm.expirationMode, //到期提醒方式
            pubVeriCoupMode: this.ruleForm.pubVeriCoupMode, //核销提醒方式
            allUser: this.ruleForm.allUser, //限制销售等级
            top: this.ruleForm.top, //置顶
            topSortIndex: this.ruleForm.topSortIndex, //置顶序列号
            expirationTime: this.ruleForm.expirationTime, //到期提醒天数
            commKind: this.ruleForm.commKind,
            giftID: this.ruleForm.giftID, //礼品ID
            giftName: this.ruleForm.giftName,//礼品
            lblPrice: this.ruleForm.lblPrice, //吊牌价,
            collectMethod: this.changItem,
            deadLine: this.ruleForm.deadLine, //领取期限
            siteLimitFlag: this.ruleForm.siteLimitFlag, //领取场限制
            tCommsitelimitList: [],
            tCommskustockList: [],
            commColorImgList: commColorImgList,
            image1: this.coverImage[0],
            image2: this.coverImage[1],
            image3: this.coverImage[2],
            allServShop:this.ruleForm.allServShop,
            servOrgList:this.ruleForm.allServShop ? []:this.ruleForm.servOrgList.map(item => {return {shopID:item.shopID}})
          };

          if (this.ruleForm.siteLimitFlag == 0) {
            this.querArrback.tCommsitelimitList = null;
          }
          if (this.ruleForm.siteLimitFlag == 2) {
            this.querArrback.tCommsitelimitList = this.city;
          }
          if (this.ruleForm.siteLimitFlag == 1) {
            this.shop.forEach((item) => {
              this.querArrback.tCommsitelimitList.push({
                siteName: item.ShopCode,
                hasStock: item.hasStock,
                state: item.state,
              });
            });
          }

          this.tCommskustockList.forEach((item) => {
            if (item.selectOption === 1) {
              this.querArrback.tCommskustockList.push(item);
            }
          });
          upperOrLowerinsert(this.querArrback).then((res) => {
            if (res.message === "success") {
              this.$message.success("创建成功");
              this.$router.push({
                path: "/Commodity",
              });
            }
          });
        }
      });
    },
    deletesizebtn (index, rowes) {
      rowes.splice(index, 1);
    },
    deletesizeoes (index, rowes) {
      rowes.splice(index, 1);
    },
    //城市添加
    citybtn () {
      let space = {
        siteName: "",
        state: "",
        hasStock: "",
      };
      if (this.ruleForm.siteLimitFlag === "2") {
        this.city.push(space);
      }
    },
    // 门店增加
    shopbtn () {
      let space = {
        siteName: "",
        state: "",
        hasStock: "",
      };
      if (this.ruleForm.siteLimitFlag === "1") {
        this.shop.push(space);
      }
    },
    //图片上传   颜色
    handleImport (file) {
      let x = { id: "", imagesArry: [] };
      const params = new FormData();
      params.append("file", file.file);
      imageupadatApi(params)
        .then((res) => {
          if (res.data) {
            if (this.imageList.length > 0) {
              let count = 0;
              this.imageList.map((item, index) => {
                if (item.id == file.data.id) {
                  this.imageList[index].imagesArry.push(res.data);
                } else {
                  count += 1;
                }
              });
              if (count == this.imageList.length) {
                (x.id = file.data.id), x.imagesArry.push(res.data);
                this.imageList.push(x);
              }
            } else {
              (x.id = file.data.id), x.imagesArry.push(res.data);
              this.imageList.push(x);
            }
          }
        })
        .catch(() => {
          this.$message.error("导入失败!");
        });
    },
    // 封面
    handleImports (file) {
      const params = new FormData();
      params.append("file", file.file);
      imageupadatApi(params)
        .then((res) => {
          if (res.data) {
            this.coverImage.push(res.data);
          }
          this.$message.success("上传成功！");
        })
        .catch(() => {
          this.$message.error("上传失败!");
        });
    },
    clearbtn () {
      this.$router.push({
        path: "/Commodity",
      });
    },
    //会员等级
    async customermethods () {
      await customerlevelApi().then((res) => {
        this.checkList = res.data;
      });
    },
    //门店模糊查询
    handleSelect (val, tel) {
      this.shop.forEach((item) => {
        if (item.ShopCode == tel) {
          item.siteName = val.name;
        }
      });
    },
    //门店编号模糊查询
    querySearch (queryString, cb) {
      var shopList = this.shopList;
      var results = queryString
        ? shopList.filter(this.createFilter(queryString))
        : shopList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter (queryString) {
      return (shoplis) => {
        return (
          shoplis.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    giftDaTeurl () {
      if (this.ruleForm.couponsName === "") {
        console.log("111");
      } else {
        this.$router.push({
          path: "/GiftLookup",
          query: {
            couper: this.JuankuRadios.couponsGrpID,
          },
        });
      }
    },
    checkboxCliock (id, type) {
      this.tCommskustockList.forEach((item) => {
        if (item.giftSKUID == id) {
          item.selectOption = type === 1 ? 0 : 1;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
/deep/.checkbox .el-checkbox-group .el-checkbox .el-checkbox__input {
  margin-top: -75px !important;
}
#giftcreate {
  height: auto;
  padding-bottom: 50px;
}
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.card-pagination {
  height: 50px;
}

// input框的圆角取消
/deep/input {
  border-radius: 0 !important;
}
//改变Upload 上传组件大小
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
}
/deep/ .el-upload {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
}

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }

  .choice,
  .present {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .el-table .el-table__cell {
    .el-input--small .el-input__inner {
      border: 0;
      text-align: center;
    }
  }
  .flex-between input.el-input__inner {
    text-decoration: underline;
    color: blue;
  }
}
.cashcreation {
  margin-bottom: 100px;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
.header-text1 {
  height: 3.5rem;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: flex-end;
  width: 250px;
  height: 50px;
  align-content: center;
}
.push-button {
  width: 100px;
  color: #a19b59;
}
</style>
